module.exports = __webpack_public_path__ + "img/banner-m.46b9da7a.png";